export default function getKCPErrorMessage(errorCode: string) {
  // @ts-ignore
  return errors[errorCode] ?? '결제 중 오류가 발생했습니다.'
};

const errors = {
  CC01: '카드사로 문의',
  CC02: 'KCP로 문의(☏1544-8661)',
  C003: '에러메시지3',
  CC04: '분실 혹은 거래불가 카드',
  CC10: '통장 잔액부족',
  CC12: '카드사 미등록 업무',
  CC13: '거래금액오류',
  CC14: '카드번호 오류',
  CC15: '미등록 카드사',
  CC16: '할부개월수 오류',
  CC17: '거래개시일자 오류',
  CC18: '거래개시시간 오류',
  CC19: '거래고유번호 오류',
  CC20: '승인번호오류',
  CC21: '미등록 가맹점',
  CC25: '안심결제|CAVV 전문 오류',
  CC26: '안심결제|CAVV 값 불일치',
  CC27: '안심결제|온라인가맹점 거래 불가',
  CC28: '안심결제|승인된 CAVV거래 취소후 거래',
  CC33: '미등록가맹점',
  CC34: '할부불가가맹점',
  CC35: 'KEY-IN불가가맹점',
  CC36: '기타거래불가가맹점',
  CC37: '인증거래미약정가맹점',
  CC39: '기타거래불가카드',
  CC43: '도난카드',
  CC44: '연체카드',
  CC45: '정지카드',
  CC46: '기타거래불가카드',
  CC47: '할부불가카드',
  CC54: '카드유효기간만료 또는 불일치',
  CC55: '유효기간 오류',
  CC61: '거래금액 한도초과',
  CC62: '가맹점 한도초과',
  CC63: '비밀번호 오류',
  CC64: 'CVC 오류',
  CC65: '사용횟수 초과',
  CC66: '주민번호 오류',
  CC67: '사업자번호 오류(인증)',
  CC68: '사업자번호 DB와 불일치',
  CC69: '인증오류 3회초과(당일거래 불가)',
  CC71: '승인번호 불일치',
  CC72: '카드사 타임 아웃',
  CC73: '가맹점 포맷 오류',
  CC80: '서비스 대상카드 아님',
  CC81: '서비스 대상카드 아님',
  CC82: '조회 불가능 카드',
  CC84: '사업자번호 오류',
  CC88: '카드사포인트 잔액부족',
  CC97: '카드사 포맷 오류',
  CC98: '카드사 시스템 장애',
  CC99: 'KCP 시스템 장애',
  CCA1: '원거래 없음',
  CCA2: '현재 승인된 상태, 매입취소 불가',
  CCA3: '현재 매입완료 상태',
  CCA4: '현재 매입취소 상태',
  CCA5: '현재 매입상태로 배치종료된 상태',
  CCA6: '승인취소된 거래 혹은 매입취소 불가',
  CCA7: '현재 매입취소된 상태로 배치종료된 상태',
  CCAA: '현재 매입요청된 상태',
  CCAB: '현재 매입취소요청된 상태',
  CCAC: '기타 승인취소 불가 거래 상태',
  CCAD: '기타 매입요청 불가 거래 상태',
  CCAE: '기타 매입취소 불가 거래 상태',
  CCB1: '이미 종료된 BATCH',
  CCB2: '잘못된 배치번호',
  CCB3: '금일 배치종료 완료',
  CCB4: '수동배치종료 불가가맹점',
  CCP1: '공인인증|전문형식 오류',
  CCP2: '공인인증|인증서 유효기간 만료',
  CCP3: '공인인증|폐기된 공인인증서',
  CCP4: '공인인증|효력 정지된 공인인증서',
  CCP5: '공인인증|미확인 공인인증서',
  CCP6: '공인인증|인증기관 인증서 만료',
  CCP7: '공인인증|공인인증서 소유자 불일치',
  CCP8: '공인인증|루트 인증서 읽기 오류',
  CCP9: '공인인증|기타 오류',
  CCPA: '공인인증|연결 실패',
  CCPB: '공인인증|전송 오류',
  CCPC: '공인인증|타임 아웃',
  CCPD: '공인인증|수신 오류',
  CCPE: '공인인증|지원되지않는 서비스코드',
  CCPG: '공인인증|승인시간간격 초과',
  CCPH: '공인인증|공인인증미등록 승인요청',
  CCPI: '공인인증|검증에러',
  CCPJ: '공인인증|공인인증서 서명 오류',
  CCS0: '[승인거절] 본인확인 후 사용가능 02-330-5720 전화요망',
  CCS1: '안전결제|취급기관 오류',
  CCS2: '안전결제|유효하지 않은 인증서',
  CCS3: '안전결제|고객 서명 오류',
  CCS4: '안전결제|유효하지 않은 ISP 인증서',
  CCS5: '안전결제|카드번호 없음',
  CCS6: '안전결제|미등록 사용자',
  CCS7: '안전결제|승인전문 오류',
  CCS8: '안전결제|복호화 에러',
  CCS9: '안전결제|카드정보 없음',
  CCSA: '안전결제|폐기된 인증서',
  CCSB: '안전결제|전자서명 검증 에러',
  CCSC: '안전결제|이중 거래',
  CCSD: '안전결제|수신 데이터 UNPACK',
  CCSE: '안전결제|거래 타임아웃',
  CCSF: '안전결제|전자서명 금액 오류',
  CCSG: '안전결제|전자서명 통화코드 오류',
  CCSH: '안전결제|전자서명 할부기간 오류',
  CCSJ: '안전결제|우리카드전화요망 1588-9955(8)',
  CCSK: '안전결제|카드사전화요망 080-520-4288',
  CCSL: '안전결제|ISP 미발급',
  CCTO: 'KCP TIME-OUT',
  CP01: '미등록 쿠폰',
  CP02: '유효기간 만료된 쿠폰',
  CP03: '사용 완료된 쿠폰',
  CP04: '할인적용 최소금액 오류',
  CP05: '쿠폰금액 불일치',
  CP06: '쿠폰발급키 불일치',
  CP07: '할인적용 최대금액 초과',
  CP11: '원거래 없음',
  CP12: '이미 취소된 거래',
  CP19: '기타 승인취소 불가',
  H002: '서버접속오류',
  H082: 'tx_cd 오류',
  NAA6: 'BC 탑포인트|이미 취소된 거래',
  S102: '연동 모듈 실행 오류',
  S202: '서버접속오류',
  YM03: '존재하지 않는 쇼핑몰이며 사업자번호도 비정상입니다. 파라미터정보 오류[쇼핑몰 관리자에게 문의]',
  YM08: '결제에 필요한 파라미터에 오류가 있습니다.( 사이트코드 값이 이상 ) [쇼핑몰 관리자에게 문의]',
  '9999': '통상적으로 카드비밀번호 3회오류 또는 카드가 은행 BC카드 일때 카드은행을 선택해서 생기는 오류입니다.'
};
